import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Location } from '@angular/common';
import { AgenciesService } from 'app/services/agencies/agencies.service';
import { PiecesService } from 'app/services/pieces/pieces.service';
import { ProjetsService } from 'app/services/projets/projets.service';
import { AwscontrolService } from 'app/services/aws/awscontrol.service';
import Swal from 'sweetalert2';

@Component({
  selector: 'app-appartement-list',
  templateUrl: './appartement-list.component.html',
  styleUrls: ['./appartement-list.component.scss']
})
export class AppartementListComponent implements OnInit {
  idAgency: any;
  Agency: any;
  list: any;

  constructor(
    private agencieService: AgenciesService,
    private piecesService: PiecesService,
    private activatedRoute: ActivatedRoute,
    private ProjetService: ProjetsService,
    private location: Location,
    private awsService: AwscontrolService
  ) { }
  
  getData() {
    this.ProjetService.getProjet(this.idAgency).subscribe(data => {
      this.Agency = data;
      this.list = this.Agency.pieces;
    });
  }
  
  ngOnInit(): void {
    this.idAgency = this.activatedRoute.snapshot.paramMap.get('id');
    this.getData();
  }

  deletePiece(piece: any) {
    Swal.fire({
      title: "Êtes-vous sûr(e) ?",
      text: "Vous ne pourrez pas revenir en arrière !",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Oui, supprimez-le."
    }).then((result) => {
      if (result.isConfirmed) {
        if (piece.photos && piece.photos.length > 0) {
          // If you want to delete image from AWS first
          this.deleteImageFromAWS(piece.photos[0], piece.id);
        } else {
          this.deletePieceFromBackend(piece.id);
        }
      }
    });
  }

  private deleteImageFromAWS(imageUrl: string, pieceId: string): void {
    this.awsService.deleteFile(imageUrl).subscribe({
      next: () => this.deletePieceFromBackend(pieceId),
      error: () => this.deletePieceFromBackend(pieceId)
    });
  }

  private deletePieceFromBackend(pieceId: string): void {
    this.piecesService.deletePiece(pieceId).subscribe({
      next: () => {
        Swal.fire("Supprimé!", "La pièce a été supprimée.", "success");
        this.getData();
      },
      error: () => {
        Swal.fire("Erreur!", "Échec de la suppression.", "error");
      }
    });
  }

  navigateBack() {
    this.location.back();
  }
}